import { ITemplatesStore } from '../index'
import { IToggleTemplateSendModal } from '../../../actions/templates/templateSendModal'

export default function(
  store: ITemplatesStore,
  action: IToggleTemplateSendModal,
): ITemplatesStore {
  return {
    ...store,
    templateSendModal: {
      email: action.email,
      event: action.toggle ? action.event : null,
      isLoading: action.toggle,
      open: action.toggle,
    },
  }
}
